module.exports = {
  // 公用部分
  new: "新建",
  query: "查詢",
  reset: "重置",
  save: "保存",
  exit: "退出",
  clean: "清除",
  choose: "選擇",
  del: "刪除",
  back: "返回",
  saveAndBack: "保存並返回",
  remove: "移除",
  add: "添加",
  saveAndNew: "保存並新建",
  cancel: "取消",
  confirm: "確定",
  enter: "進入",
  signin: "登陸",
  refresh: "刷新",
  verify_link: "驗證鏈接",
  synchronize_domain: "同步域(租戶)組織架構到微信企業號",
  synchronize_organizational: "同步微信企業號組織架構到域(租戶)",
  sync_dinging2org: "同步域(租戶)組織架構到釘釘企業號",
  sync_dingding2domain: "同步釘釘企業號組織架構到域(租戶)",
  edit: "編輯",
  clearConfig: "清除緩存數據",
  clearConfigId: "清除冗余數據",
  synchronization: "同步數據表單",
  indexOptimization: "索引優化",
  import: "導入",
  export: "導出",
  exportAll:'導出全部',
  admin: "管理員",
  name: "名稱",
  loginno: "賬號",
  email: "電子郵箱",
  tel: "手機",
  username: "用戶名稱",
  password: "密碼",
  public: "公開",
  // login
  character: "字符",
  error: "錯誤",
  login: "登錄",
  // home
  home: "主頁",
  loginout: "註銷",
  closeHelp: "幫助",
  platform: "管理員中心",
  enterprise_domain: "域(租戶)管理",
  superuser: "特權用戶管理",
  systemCon: "系統管理",
  systemMoni: "系統監控",
  debugmode: "調試模式",
  // main
  location: "當前位置：主頁",
  enterprise_list: "域(租戶)列表",
  enterprise_name: "域(租戶)名稱",
  active: "激活",
  inactive: "不激活",
  activated: '已激活',
  inactivated: "未激活",
  // domain
  detail: "詳情",
  baseInfo: "基本信息",
  department: "部門",
  user: "用戶",
  appconfig: "軟件",
  weixinConfig: "微信配置",
  dingdingConfig: "釘釘配置",
  calendar: "工作日歷",
  fieldextend: "字段擴展",
  userlog: "操作日誌",
  flowstaterts: "流程監控",
  emailconfig: "郵件設置",
  timedtask: "定時任務",
  // baseinfo
  base_info_setting: "基本信息設置",
  enterprise_info: "域(租戶)信息",
  skinType: "選擇皮膚",
  smsMemberCode: "天翎短信平臺帳號",
  smsMemberPwd: "天翎短信平臺密碼",
  testSMS: "測試短信發送",
  noAccount: "還沒有帳號?",
  wantToChangePwd: "修改密碼?請登錄天翎短信平臺！",
  systemName: "系統名稱",
  description: "描述",
  status: "是否有效",
  setSuperior: "設置上級",
  superior: "上級",
  subordinate: "下級",
  // department
  department_import: '部門導入',
  dept_list: "部門列表",
  dept_name: "部門名稱",
  superior_dept: "上級部門",
  level: "層級",
  dept_info: "部門信息",
  orderByNo: "排序號",
  select_dept: "選擇部門",
  code: "代碼",
  valid: "有效性",
  owned_user: "所屬用戶",
  // user
  user_list: "用戶列表",
  user_import: "用戶導入",
  user_export: "用戶導出",
  user_name: "用戶姓名",
  user_no: "用戶賬號",
  superior_name: "上級用戶",
  select_role: "請選擇角色",
  select_software: "請選擇軟件",
  dimission_status: "狀態",
  resign: "Invalid",
  on_job: "Normal",
  // user_detail
  user_info: "用戶信息",
  settingInfo: "設置信息",
  moreInfo: '更多信息',
  proxyUser: "代理人用戶",
  startProxyTime: "代理開始日期",
  endProxyTime: "代理結束日期",
  domainUser: "部門管理員",
  address_book: "通訊錄中個人信息",
  liaisonOfficer: "部門接口人",
  lockFlag: "登錄異常鎖定",
  useIM: "使用即時通訊",
  dimission: "是否離職",
  add_dept: "添加部門",
  setDefault: "設置為默認",
  datetime: "選擇日期時間",
  setRole: "設置角色",
  kmSetting: "KM管理",
  staff: "員工",
  dept_know_manager: "部門知識管理員",
  committee_know_manager: "專委會知識管理員",
  enterprise_know_manager: "企業知識管理員",
  // appconfig
  basic_software_config: "基礎軟件配置",
  pmEnable: "啟用任務管理軟件",
  qmEnable: "啟用調查問卷軟件",
  amEnable: "啟用微考勤軟件",
  cmEnable: "啟用聯系人管理軟件",
  pcmEnable: "流程中心",
  kmEnable: "啟用知識文檔管理軟件",
  kmTeamEnable: "團隊",
  kmRealmEnable: "知識專題",
  km_role: "KM角色管理",
  custom_software: "自定義軟件配置",
  software_name: "軟件名稱",
  mode: "模式",
  regular_mode: "常規模式",
  platform_mode: "平臺模式",
  operating: "操作",
  export_operation: "導出操作",
  fettle: "狀態",
  add_role: "角色添加",
  bpm_Mode_Conf: "BPM平臺模式配置",
  role_menu: "角色&菜單",
  role_user: "角色&用戶",
  // appconfig_add
  appconfig_add: "添加軟件",
  // superuser
  super_user_list: "特權用戶列表",
  user_type: "用戶類型",
  superAdmin: "超級管理員",
  secret: "安全保密員",
  develop: "開發者",
  examine: "安全審查員",
  system_admin: "系統管理員",
  // superuser_detail
  superuser_detail: "特權用戶詳情",
  add_field: "添加字段",
  management_scope: "管理範圍",
  belong_domains: "所屬域",
  belong_dept: "所屬部門",
  key: "密鑰",
  generate: "生成",
  // 系統監控
  system_monitoring: "系統監控",
  server_monitoring: "服務器監控",
  druid_Monitor: "對數據源連接情況、sql執行效率、sql防火墻、web並發、session等多維度的實時監控",
  jamon: "監控宏語言、系統類方法及Sql的執行效率",
  swagger2: "Swagger接口文檔",
  web_services: "web-services調用和執行情況",
  onlineUsers: "監控服務器當前在線用戶會話(Session)情況",
  // swagger
  domain: "域(租戶)",
  front_user: "前臺用戶",
  // onlineuser
  online_user: "在線用戶",
  online_num: "當前在線用戶數：",
  login_time: "登錄時間",
  off_line: "強制下線",
  // jamen
  is_open_monitoring: "是否開啟監控：",
  // manager
  manager_list: "管理員列表",
  // user_select
  add_admin_list: "添加管理員列表",
  // weixin
  activate_weChat: "啟用微信企業號",
  no_wechat_service: "不開啟微信服務",
  enterprise_wechat: "手工配置模式(企業微信)",
  startup: "啟動",
  weixincorpID: "企業微信CorpID",
  weixinCorpSecret: "通訊錄Secret",
  serverHost: "外網訪問系統地址",
  verification_link: "驗證鏈接",
  weixinQrCodeAgentId: "微信掃碼AgentId",
  weixinQrCodeSecret: "微信掃碼Secret",
  weixinQrCodeCallbackUrl: "微信掃碼CallbackUrl",
  enabled_software: "已啟用的軟件列表",
  weixinAgentId: "*微信應用AgentId",
  weixinSecret: "*微信應用Secret",
  weChatURL: "微信菜單跳轉鏈接",
  jumplink: "生成跳轉鏈接",
  // weixinUrl
  weixinUrl: '微信端配置',
  menuName: '菜單名稱',
  jump_link: '跳轉鏈接',
  // rolelist
  rolelist: "角色列表",
  rolename: "角色名稱",
  // dingding
  activate_dingding: "啟用釘釘企業號",
  no_dingding_service: "不開啟釘釘服務",
  enterprise_dingding: "手工配置模式(釘釘)",
  dingdingCorpID: "企業釘釘CorpID",
  dingdingServerHost: "外網訪問系統地址",
  address_book_application: "通訊錄應用",
  dingdingAgentId: "通訊錄AgentId",
  dingdingKey: "通訊錄AppKey",
  dingdingSecret: "通訊錄AppSecret",
  scancode: "掃碼設置",
  dingdingQrCodeAppId: "釘釘掃碼appid",
  dingdingQrCodeAppSecret: "釘釘掃碼appSecret",
  dingdingQrCodeCallbackUrl: "釘釘掃碼重定向地址",
  dingdingAppAgentId: "*釘釘應用AgentId",
  dingdingAppKey: "*釘釘應用AppKey",
  dingdingAppSecret: "*釘釘應用Secret",
  dingdingURL: "釘釘菜單跳轉鏈接",
  // calendar
  calendarList: "工作日歷列表",
  calendarName: "日歷名稱",
  // calendar_detail
  new_calendar: "新建工作日歷",
  edit_calendar: "修改工作日歷",
  from_calendar: "從日歷",
  copy_calendar: "復制至新日歷名稱",
  // userlog
  log: "操作日誌",
  userlog_record: "是否記錄用戶操作日誌：",
  operator: "操作人",
  select_date: "選擇日期",
  type: "類型",
  date: "日期",
  // flowstatert
  flowName: "流程名稱",
  stateLabel: "當前節點",
  initiator: "發起人",
  firstProcessTime: "流程開始時間",
  lastAuditor: "最後處理人",
  lastProcessTime: "最後處理時間",
  summary: "摘要",
  flowboard: "流程儀表盤",
  // flowstaterts
  today: "今天",
  week: "本周",
  month: "本月",
  year: "年",
  show_user: "顯示所有用戶",
  time_consuming: "流程節點耗時-TOP10",
  startnodename: "開始節點名稱",
  endnodename: "結束節點名稱",
  auditor: "處理人",
  amount: "耗時(H)",
  nodata: "暫無數據",
  // flowstaterts_detail
  flowstaterts_detail: "流程詳情",
  flow_intervention: "流程幹預",
  add_intervention_node: "添加幹預節點",
  node_approver: "節點審批人",
  intervention_node: "幹預節點",
  flow_node: "後臺幹預至流程節點",
  flow_node_after_intervention: "幹預後流程節點處理人",
  // emailconfig
  mail_setting: "系統郵件發送設置",
  sendHost: "發送主機",
  sendAddress: "發出地址",
  sendAccount: "發送賬號",
  sendPassword: "發送密碼",
  ccAddress: "抄送地址",
  base_setting: "基本設置",
  isUseClient: "是否使用客戶端",
  functionDomain: "郵件功能域",
  file_mapping: "郵件客戶端與服務器的文件映射",
  trash: "垃圾箱",
  sender: "發送箱",
  draft: "草稿",
  removed: "已刪除",
  fetchssl: "是否需要證書",
  fetchServer_config: "收件服務器配置",
  fetchServer: "收取郵件服務器",
  fetchServerPort: "收取郵件服務器端口",
  fetchProtocol: "收取郵件協議",
  send_serve_config: "發送服務器配置",
  smtpServer: "發送郵件服務器",
  smtpServerPort: "發送郵件服務器端口",
  smtpAuthenticated: "是否可帶附件",
  smtpssl: "是否需要證書",
  // timedtask
  start: "開始",
  creator: "創建人",
  startup_type: "啟動類型",
  runtime: "運行時間",
  runnum: "運行次數",
  period: "周期",
  manual: "手動",
  auto: "自動",
  banned: "禁止",
  state: "狀態",
  stoped: "停止",
  run: "運行",
  do_not_repeat: "不重復",
  immediately: "立刻",
  minute: "分鐘",
  hour: "小時",
  day: "每日",
  weeks: "每周",
  months: "每月",
  running_on: "運行在",
  sunday: "星期日",
  monday: "星期一",
  tuesday: "星期二",
  wednesday: "星期三",
  thursday: "星期四",
  friday: "星期五",
  saturday: "星期六",

  // fieldextend
  string: "字符串",
  clob: "大字段",
  radio: "單選框",
  checkbox: "復選框",
  address: "地址",
  select: "下拉框",
  upload: '圖片上傳',
  owned_field: "所屬字段",
  show_label: "顯示標簽",
  tableUser: "用戶模塊",
  tableDept: "部門模塊",
  tableDomain: "域模塊",
  show_list: "是否在列表中顯示",
  show: "顯示",
  not_show: "不顯示",
  // fieldextend_detail
  owned_module: "所屬模塊",
  yes: "是",
  no: "否",
  order: "排序",
  isRequire: "是否必填",
  isRead: '是否只讀',
  isQuery: '是否查詢',
  options: "自定義選項(請用;隔開)",
  // systemcon
  authConfig: "身份驗證設置",
  LDAP: "LDAP設置",
  policy: "用戶密碼策略",
  manage: "緩存與數據管理",
  hxImConfig: "環信配置",
  SystemFile: '系統字段',
  // config
  userstohx: "同步用戶",
  hx_manage: "HX管理後臺",
  // authconfig
  multiuserlogin: "是否允許多點登錄",
  haveImg: "登錄背景圖片設置",
  uploadBgImg: "上傳",
  cleanBgImg: "清除",
  authType: "身份驗證模式：",
  interface: "界面登錄",
  sso: "單點登錄",
  ssl_pkcs12: "通過PKCS12客戶端證書登錄",
  smsAuthenticate: "是否開啟手機短信驗證：(註意:開啟手機短信驗證需要重啟服務器後才生效)",
  smsAffectMode: "作用類型：",
  all: "所有",
  match: "匹配ip範圍",
  exclude: "排除ip範圍",
  ip_range: "作用ip範圍：",
  smsTimeout: "超時（單位“秒”）：",
  smsContent: "短信內容(“$”代表驗證碼)：",
  checkldap: "單點登錄驗證方式：",
  ssoRedirect: "首頁重定向地址：",
  ssoLogoutRedirect: "註銷重定向地址：",
  localServerName: "cas服務器名稱：",
  casLoginUrl: "cas服務器登錄url：",
  casUrlPrefix: "cas服務器url前綴：",
  adDomainController: "AD域所在服務器IP：",
  adDefaultDomain: "AD域名：",
  adadminloginno: "AD域所在服務器管理員賬號：",
  adadminloginnopw: "AD域所在服務器管理員密碼：",
  adlogindomain: "AD域登錄域(租戶)：",
  adjespausernmae: "JESPA用戶名：",
  adjespapassword: "JESPA密碼：",
  user_synchronization: "用戶同步設置",
  ssoDefaultEmail: "默認郵箱地址：",
  ssoDefaultPassword: "默認密碼：",
  setting_after_auth: "認證後用戶信息保存設置",
  ssoSaveType: "保存方式：",
  none: "無",
  ssoDataEncryption: "數據加密方式：",
  ssoKeyLoginAccount: "用戶登錄賬號鍵名稱：",
  ssoKeyDomain: "域(租戶)鍵名稱：",
  ssoKeyEmail: "用戶郵箱鍵名稱：",
  // LDAP
  ldapurl: "LDAP服務器地址：",
  dirStructure: "用戶DN：",
  pooled: "是否池化：",
  manager_account: "管理賬戶：",
  managerPassword: "管理賬戶密碼：",
  ldap_mapping: "LDAP用戶字段映射設置",
  userClass: "用戶類:",
  id_: "用戶ID：",
  name_: "用戶名稱：",
  loginno_: "用戶登錄賬號：",
  loginpwd_: "用戶登錄密碼：",
  email_: "郵箱地址：",
  telephone_: "電話號碼：",
  ldap_dept: "部門字段映射設置",
  deptClass: "部門類: ",
  enterDept: "頂級部門:",
  // policy
  min_length: "最小密碼長度：",
  max_length_tip: "（設置值不能超過系統密碼最大長度值，此項不填默認為1）",
  failLoginTimes: "最多錯誤輸入密碼錯誤次數：",
  nocheck: "（不填則不做此項檢查）",
  legal: "密碼同時由英文大小寫特殊字符和數字構成：",
  pwd_change: "密碼修改通知策略",
  noticeAuthor: "密碼永不過期：",
  maxAge: "密碼過期時間（天）：",
  noticeTime: "幾天後通知修改密碼（天）：",
  noticeMethodArr: "密碼修改通知方式：",
  sms: "短信",
  msg_center: "消息中心",
  noticeContent: "通知內容：",
  // manage
  clean_cache: "此操作會清除服務器上所有數據的緩存",
  select_soft: "請選擇軟件:",
  cache_manage: "緩存管理",
  data_manage: "數據管理",
  clean_redundant: "此操作會清除業務庫的冗余數據",
  // icon_select
  select_icon: "選擇圖標",
  picture_icon: "圖片圖標",
  customIcon: "自定義圖標",
  upload_icon: "上傳圖標",
  batch_editing: "批量編輯",
  cancel_edit: "取消編輯",
  batch_delete: "批量刪除",
  select_all: "全選",
  // roleBatchUser
  select_user: "選擇用戶",
  please_select_dept: "請選擇部門",
  // kmrolemanager
  select_roles: "角色選擇",
  // fileUpload
  annex: '附件：',
  importing: '正在導入中',
  download_template: '點擊下載模板',
  upload_txt: '將文件拖到此處，或',
  upload_click: '點擊上傳',
  upload_img: '圖片上傳',
  upload_bgImg: '登錄背景圖片上傳',
  upload_custom_icon: '自定義圖標上傳',
  excel_user_import: 'Excel用戶導入',
  // add_deportment
  select_superior_dept: '選擇上級部門',
  // 公用提示
  msg_tip: "提示",
  placeholder_select: "請選擇",
  placeholder_enter_content: "請輸入內容",
  msg_send_success : "發送成功",
  msg_send_fail: "發送失敗",
  msg_name: '請輸入用戶名稱',
  msg_account: '請輸入賬號',
  msg_pwd: '請輸入密碼',
  msg_email: '請輸入郵箱',
  msg_length: '長度在 1 到 15 個字符',
  msg_eamilFormat: '郵箱格式不正確',
  msg_require_tel: "請輸入手機號碼",
  msg_incorrect_phone: "手機號碼格式不正確",
  msg_require_name: "用戶名稱為必填項",
  msg_special_char: "用戶名稱不能輸入特殊字符",
  msg_require_loginno: "賬號為必填項",
  msg_orderno_negative: "排序號不能為負數",
  msg_require_calendar: "日歷為必填項",
  msg_tel_incorrectly: "手機號輸入有誤",
  msg_email_incorrectly: "電子信箱輸入有誤",
  msg_require_dept: "用戶必須選擇部門",
  msg_select_role: "用戶必須選擇軟件角色",
  msg_startProxyTime: "請填寫代理開始日期",
  msg_endProxyTime: "請填寫代理結束日期",
  msg_require_password: "用戶密碼為必填項",
  msg_default_dept: "默認部門為必填項",
  msg_save_success: "保存成功!",
  msg_select_software: "請選擇一個軟件",
  msg_remove_success: "移除成功",
  msg_del_success: "刪除成功!",
  msg_select_superuser: "請先選擇一個特權用戶",
  msg_select_domain: "請先選擇域(租戶)",
  msg_select_user: "請先選擇用戶",
  msg_offline: "強制下線成功",
  msg_add_success: "添加成功!",
  msg_timeout: "連接超時!",
  msg_verified_success: "驗證成功",
  msg_verified_failed: "驗證失敗",
  msg_require_agentId: "請填寫微信應用AgentId",
  msg_require_secret: "請填寫微信應用Secret",
  msg_cancel: "取消輸入",
  msg_require_dingdingAgentId: "請填寫釘釘應用AgentId",
  msg_require_dingdingAppKey: "請填寫釘釘應用Secret",
  msg_require_dingdingAppSecret: "請填寫釘釘應用Secret",
  msg_del_failed: "刪除失敗",
  msg_cancel_del: "已取消刪除",
  msg_del_calendar: "請選擇一個日歷進行刪除",
  msg_calendar_exist: "該日歷名稱已存在!",
  msg_require_calendarName: "請填寫新日歷名稱!",
  msg_require_calendarId:'請填寫從日曆',
  msg_new_success: "新建成功!",
  msg_select_data: "請至少選擇一條數據",
  msg_select_flowdata: "請至少選擇一條流程進行刪除",
  km_tip: "(選擇需要設置KM角色的用戶，此次設置將會清空用戶原來的角色設置，未選擇的用戶將不受影響)",
  msg_select_dept: '請選擇一個部門',
  msg_upload_file: '請上傳文件!',
  msg_err_upload: '上傳失敗',
  msg_upload_success: '導入成功!',
  msg_select_img: '請先選擇一個圖標!',
  msg_filter: '輸入關鍵字進行過濾',
  msg_select_admin: '請先選擇一個管理員',
};
